var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobExpe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#F9FAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 10.6667C16.6666 10.0467 16.6666 9.7367 16.5984 9.48236C16.4135 8.79218 15.8744 8.25308 15.1842 8.06815C14.9299 8 14.6199 8 13.9999 8C13.3799 8 13.0699 8 12.8156 8.06815C12.1254 8.25308 11.5863 8.79218 11.4014 9.48236C11.3333 9.7367 11.3333 10.0467 11.3333 10.6667M9.46659 20H18.5333C19.28 20 19.6534 20 19.9386 19.8547C20.1895 19.7268 20.3934 19.5229 20.5213 19.272C20.6666 18.9868 20.6666 18.6134 20.6666 17.8667V12.8C20.6666 12.0533 20.6666 11.6799 20.5213 11.3947C20.3934 11.1438 20.1895 10.9398 19.9386 10.812C19.6534 10.6667 19.28 10.6667 18.5333 10.6667H9.46659C8.71985 10.6667 8.34648 10.6667 8.06126 10.812C7.81038 10.9398 7.60641 11.1438 7.47858 11.3947C7.33325 11.6799 7.33325 12.0533 7.33325 12.8V17.8667C7.33325 18.6134 7.33325 18.9868 7.47858 19.272C7.60641 19.5229 7.81038 19.7268 8.06126 19.8547C8.34648 20 8.71985 20 9.46659 20Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobExpe);
export default __webpack_public_path__ + "static/media/job-expe.564afd123bdc4a3c4b880b0f8e0f6262.svg";
export { ForwardRef as ReactComponent };